var map = {
	"./Chat/addendum_icon.svg": "486a",
	"./Chat/arrow_icon.svg": "eae7",
	"./Chat/btn_control_icon.svg": "ec72",
	"./Chat/camera_icon.svg": "8106",
	"./Chat/chat.svg": "e20d",
	"./Chat/list_icon.svg": "aabb",
	"./Chat/message_icon.svg": "3500",
	"./Chat/more_icon.svg": "f552",
	"./Chat/plus_icon.svg": "88c6",
	"./Chat/save_icon.svg": "f800",
	"./Chat/support_icon.svg": "cef5",
	"./LeftSidebar/icon1.svg": "1ec3",
	"./LeftSidebar/icon2.svg": "ce37",
	"./LeftSidebar/icon3.svg": "d0b2",
	"./LeftSidebar/icon4.svg": "8ab8",
	"./LeftSidebar/icon5.svg": "dd4c",
	"./Menu/menu_icon.svg": "c955",
	"./MessageRecord/mic_icon.svg": "72be",
	"./MessageRecord/record_icon.svg": "af3b",
	"./MessageRecord/video_camera_icon.svg": "f9c4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";